module.exports = __webpack_public_path__ + "json/buildings-6.json?21df63b1110c2c310bc31b219930ee46";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-6.json
// module id = 1725
// module chunks = 3